import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateProjectUsersCache,
  ProjectUsersCacheEvents,
} from '@monorepo/shared/cacheRegisters/users/projectUsersCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseUpdateUserProjectRoleParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export function useUpdateUserProjectRole(
  params?: UseUpdateUserProjectRoleParams,
) {
  return useMutation(Api.updateUserProjectRole, {
    ...params?.config,
    onSuccess: (data, variables) => {
      invalidateProjectUsersCache(ProjectUsersCacheEvents.UPDATE, {
        projectId: variables.projectId,
      });
      return params?.config?.onSuccess?.(data, variables);
    },
    onError: (error, variables, rollback) =>
      params?.config?.onError?.(error, variables, rollback),
  });
}
